import { useStaticQuery, graphql } from "gatsby"

export const useCartSettings = () => {
  const { cartSettings } = useStaticQuery(graphql`
    query CART {
      cartSettings: sanitySettingCart {
        emptyText
        cartButtons {
          buttonText
          buttonLink {
            _rawDocument(resolveReferences: { maxDepth: 0 })
            document {
              ... on SanityCollection {
                metadata {
                  canonicalUrl
                }
              }
            }
          }
        }
        isTrust
        trustSlides {
          slideImg {
            asset {
              url
            }
          }
          slideText
        }
      }
    }
  `)

  const emptyText = cartSettings?.emptyText || ""
  const isTrust = cartSettings?.isTrust || false
  const cartButtons = cartSettings?.cartButtons || []
  const trustSlides = cartSettings?.trustSlides || []

  return {
    emptyText,
    cartButtons,
    isTrust,
    trustSlides,
  }
}
